// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"AppleLogin_wrapper__GlwQx","button":"AppleLogin_button__3M5Ki","container":"AppleLogin_container__1jU7r"};